import requestAction from '../../utils/requestAction'

export const fetchProductMeasurementTypes = (params: string = "") =>
  requestAction('PRODUCTMEASUREMENTTYPE_LIST', params)(`productMeasurementTypes`, 'GET')

export const fetchAllProductMeasurementTypes = () =>
  fetchProductMeasurementTypes('?all=true')